exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\r\n * Applies styles for users in high contrast mode. Note that this only applies\r\n * to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\r\n * attribute, however Chrome handles high contrast differently.\r\n */\n/* Theme for the ripple elements.*/\n/** The mixins below are shared between mat-menu and mat-select */\n/**\r\n * This mixin adds the correct panel transform styles based\r\n * on the direction that the menu panel opens.\r\n */\n/* stylelint-disable material/no-prefixes */\n/* stylelint-enable */\n/**\r\n * This mixin contains shared option styles between the select and\r\n * autocomplete components.\r\n */\n#main-navigation {\n  margin: 0;\n  padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/core/components/navigation/navigation.component.scss
// module id = ../../../../../src/app/core/components/navigation/navigation.component.scss
// module chunks = main